if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

  onSubmitHandler(evt) {
    evt.preventDefault();
    if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

    this.handleErrorMessage();

    this.submitButton.setAttribute('aria-disabled', true);
    this.submitButton.classList.add('loading');
    this.querySelector('.loading__spinner').classList.remove('hidden');

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData(this.form);
    if (this.cart) {
      formData.append(
        'sections',
        this.cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      this.cart.setActiveElement(document.activeElement);
    }

    config.body = formData;

    let mainProductResponse = null;

    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((response) => {
        mainProductResponse = response;

        // Add your custom products here - custom by developer
        return this.handleCustomproducts();
      })
      .then(() => {
        const response = mainProductResponse;

        if (response.status) {
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            errors: response.errors || response.description,
            message: response.message,
          });
          this.handleErrorMessage(response.description);

          const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
          if (!soldOutMessage) return;
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButtonText.classList.add('hidden');
          soldOutMessage.classList.remove('hidden');
          this.error = true;
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }

        const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: formData.get('id'),
            cartData: response,
          }).then(() => {
            CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
          });
        }

        this.error = false;
        const quickAddModal = this.closest('quick-add-modal');
        if (quickAddModal) {
          document.body.addEventListener(
            'modalClosed',
            () => {
              setTimeout(() => {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  this.cart.renderContents(response);
                });
              });
            },
            { once: true }
          );
          quickAddModal.hide(true);
        } else {
          CartPerformance.measure("add:paint-updated-sections", () => {
            this.cart.renderContents(response);
          });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.submitButton.classList.remove('loading');
        if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
        if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading__spinner').classList.add('hidden');

        CartPerformance.measureFromEvent("add:user-action", evt);
      });
  }


  handleCustomproducts() {
 
    const items = [];
    const seenIds = new Set();

    const cards = document.querySelectorAll(".custom-product-card");
    cards.forEach(card => {      
      const input = card.querySelector(".variant-id-input");
      if (!input) return;

      let rawValue = input.value.trim();
      let quantity;
      if( typeof card.dataset.quantity !== 'undefined' ){
          quantity = parseInt(card.dataset.quantity) || 1;
      }
      else{
          quantity = card.querySelectorAll('.variant-selector-group').length || 1;
      }      

      try {
        const parsed = JSON.parse(rawValue);
        if (Array.isArray(parsed)) {
          const qtyMap = new Map();

          parsed.forEach(rawId => {
            const id = String(rawId).trim();
            if (!id) return;

             
            // If already exists, increment qty
            if (qtyMap.has(id)) {
              qtyMap.set(id, qtyMap.get(id) + 1);
            } else {              
              qtyMap.set(id, 1); // start at 1
             // seenIds.add(id);
            }
          });

          qtyMap.forEach((quantity, id) => {
            items.push({ id, quantity });
          });

          return;
        }
      } catch (e) {
        // Not JSON
      }

      if (rawValue.startsWith("[") && rawValue.endsWith("]")) {
        rawValue = rawValue.slice(1, -1).trim();
      }

      if (rawValue && !seenIds.has(rawValue)) {
        seenIds.add(rawValue);
        items.push({ id: rawValue, quantity });
      }
    });

    if (items.length === 0) return Promise.resolve(); // Nothing to add
    console.log(JSON.stringify({ items }));
    return fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ items })
    })
      .then(response => {        
        if (!response.ok) {
          console.error("Failed to add custom products:", response.statusText);
        } else {
          console.log("Custom products added successfully.");
          this.updateMiniCartQty();
        }
      })
      .catch(error => {
        console.error("Fetch error while adding custom products:", error);
      });
  }

      updateMiniCartQty(){
        $.getJSON('/cart.js', function(cart) {
          $('.cart-count-bubble').find('span:not(.visually-hidden)').text(cart.item_count);
          $('.cart-count-bubble').find('span.visually-hidden').text('1 '+cart.item_count);
        });
      }





      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function formatShopifyPrice(cents) {
  let num = cents / 100; // convert cents to dollars
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: num % 1 === 0 ? 0 : 2,
    maximumFractionDigits: 2
  }).format(num);
}

document.addEventListener("DOMContentLoaded", () => {
  const qtyInput = document.querySelector('input[name="quantity"]');

  function updatePrices(unit, compare) {
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    if (!priceEl) return;

    const qty = parseInt(qtyInput?.value, 10) || 1;
    priceEl.querySelector('.price-per-item--current').textContent = priceEl.dataset.currency+''+formatShopifyPrice(unit * qty);

    if (compareEl) {
      if (compare && compare > unit) {
        compareEl.style.display = "inline";
        
        compareEl.querySelector('.variant-item__old-price').textContent = compareEl.dataset.currency+''+formatShopifyPrice(compare * qty);
      } else {
        compareEl.style.display = "none";
      }
    }
  }

  // When quantity changes
  qtyInput?.addEventListener("change", () => {
    // read latest values from DOM attributes
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-compare-price]');
    const unit = parseInt(priceEl?.getAttribute("data-price"), 10) || 0;
    const compare = parseInt(compareEl?.getAttribute("data-compare"), 10) || null;
    updatePrices(unit, compare);
  });
});
